import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/MallApi/goods'

export default {


    //分页
    list(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/list',
            method: 'get',
            params,
        })
    },

    //修改上架状态
    upordown(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/upordown',
            method: 'get',
            params,
        })
    },


    //添加
    add(data) {
        return request({
            url: BASE_URL + '/add',
            method: 'post',
            data
        })
    },

    //编辑
    update(data) {
        return request({
            url: BASE_URL + '/edit',
            method: 'post',
            data
        })
    },

    //删除
    delete(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/delete',
            method: 'get',
            params
        })
    },

    //规格查询
    spec(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/spec',
            method: 'get',
            params,
        })
    },

    //规格编辑
    updatespec(data) {
        return request({
            url: BASE_URL + '/update',
            method: 'post',
            data
        })
    },
    //规格删除
    deletespec(data) {
        return request({
            url: BASE_URL + '/deletespec',
            method: 'post',
            data
        })
    },
}